<template>
	  <div class="footer">
	    <div class="home-bottom ac mt50">
	      <div class="footer-content ac">
	        <div class="icon icon1" @click="getType('luckyDraw')">
	          <img src="../../static/images/menu-icon2.png" />
	          <span>{{$t('Prize')}}</span>
	          </div>
	        <div class="icon icon1" @click="getType('referral')">
	          <img src="../../static/images/menu-icon3.png" />
	          <span style="white-space: nowrap;">{{$t('referral')}}</span>
	        </div>
	        <!-- <div class="icon icon1" @click="getType('winnerList')">{{$t('winnerList')}}</div> -->
	        <div class="icon icon2" @click="getType('faq')">
	          <img src="../../static/images/menu-icon5.png" />
	          <span>{{$t('FAQs')}}</span>
	        </div>
	        <div class="icon icon3" @click="getType('termsAndCondition')">
	          <img src="../../static/images/menu-icon6.png" />
	          <span>{{$t('TC')}}</span>
	        </div>
	        <div class="icon icon4" @click="getType('language')">
	          <img src="../../static/images/menu-icon7.png" />
	          <span>{{$t('language')}}</span>
	        </div>
	      </div>
	    </div>
	    <div class="copyright">{{$t('Copyright')}}</div>
	  </div>
</template>

<script>
  import Dialog from '../components/dialog'
  export default {
      name: 'app-header',
      components:{
        Dialog
      },
      data () {
          return {
          }
      },
		methods: {
        getType(type){
            this.$router.push({path:type,query:{type:type}});
        }
		}
    }
</script>



// WEBPACK FOOTER //
// src/components/footer.vue